/** Rotas da impressão no painel. */
export const PRINTING_SETTINGS_PATH = '/settings/printing';
export const PRINTING_SETUP_PATH = '/settings/printing/setup';
export const PRINTING_PAIR_PATH = '/settings/printing/pair';

/** Âncora da lista de computadores na aba, onde está "Atualizar" (change print-agent). */
export const PRINTING_AGENTS_ANCHOR = 'computadores';
export const PRINTING_AGENTS_PATH = `${PRINTING_SETTINGS_PATH}#${PRINTING_AGENTS_ANCHOR}`;

/** A confirmação de pareamento, pelo link do instalador ou pelo código digitado. */
export function pairingPath(code: string, via: 'link' | 'code' = 'link'): string {
  const params = new URLSearchParams({ code });
  if (via === 'code') params.set('via', 'code');
  return `${PRINTING_PAIR_PATH}?${params.toString()}`;
}
